export class AccountDetails {
    public shortenedAddress: string;
    public fullAddress: string;
    public weiBalance: string;
    public displayBalance: string;

    constructor(shortenedAddress: string, fullAddress: string, weiBalance: string, displayBalance: string) {
        this.shortenedAddress = shortenedAddress;
        this.fullAddress = fullAddress;
        this.weiBalance = weiBalance;
        this.displayBalance = displayBalance; // ETH
    }
}

